/**
 * 併存尺度: Mini-IPIP 20 項目（Donnellan et al., 2006。IPIP はパブリックドメイン）。GenDan の軸が
 * 確立した性格 5 因子とどれだけ対応するか（収束妥当性）を検証するために、結果ページで任意に集める。
 * ID と並びはサーバ側 services/api/src/lib/validation.ts と同じ。日本語訳は暫定。
 */
export interface ValidationItem {
  readonly id: string;
  readonly text: string;
}

export const MINI_IPIP_ITEMS: readonly ValidationItem[] = [
  { id: 'ipip_e1', text: '集まりでは、場を盛り上げる中心になる' },
  { id: 'ipip_a1', text: '人の気持ちに寄り添う' },
  { id: 'ipip_c1', text: 'やるべき雑事は、すぐに片づける' },
  { id: 'ipip_n1', text: '気分の浮き沈みがよくある' },
  { id: 'ipip_o1', text: '想像力が豊かだ' },
  { id: 'ipip_e2', text: 'あまり多くを話さない' },
  { id: 'ipip_a2', text: '他人の悩みには、あまり関心がない' },
  { id: 'ipip_c2', text: '使ったものを元の場所に戻し忘れることが多い' },
  { id: 'ipip_n2', text: 'たいてい、リラックスしている' },
  { id: 'ipip_o2', text: '抽象的な考えには興味がない' },
  { id: 'ipip_e3', text: '集まりでは、いろいろな人と話す' },
  { id: 'ipip_a3', text: '人の感情を、自分のことのように感じる' },
  { id: 'ipip_c3', text: '整った状態が好きだ' },
  { id: 'ipip_n3', text: '動揺しやすい' },
  { id: 'ipip_o3', text: '抽象的な考えを理解するのは苦手だ' },
  { id: 'ipip_e4', text: '目立たないところにいる' },
  { id: 'ipip_a4', text: '他人には、あまり関心がない' },
  { id: 'ipip_c4', text: '物事を散らかしたままにしがちだ' },
  { id: 'ipip_n4', text: '気分が沈むことは、ほとんどない' },
  { id: 'ipip_o4', text: '想像力は、あまりない' },
];

export const VALIDATION_CONSENT =
  'この 20 問は、GenDan の診断が確立した性格の尺度とどれだけ対応するかを確かめる研究にだけ使います。' +
  '回答は診断結果と一緒に匿名で保存され、氏名やメールとは結び付きません。途中でやめても構いません。あなたの結果は変わりません。';
